module.exports = __webpack_public_path__ + "static/media/music.e8b748ce.jpg";